import React from 'react';
import { Form } from 'components/ds';
import { DynamicForm } from 'modules/account/components/DynamicForm/DynamicForm';
import { ApiLocalStorage } from 'utils/ApiLocalStorage';
import TermsCheckboxes from '../../../components/TermsCheckboxes/TermsCheckboxes';
import { USER_DATA_KEY } from '../../../constantes/LocalStorageEnum';

const Personal: React.FC = () => {
  const [form] = Form.useForm();
  return (
    <>
      <DynamicForm
        pageName="personal"
        initialValues={ApiLocalStorage.get(USER_DATA_KEY)}
        form={form}
      >
        <TermsCheckboxes form={form} />
      </DynamicForm>
    </>
  );
};

export default Personal;
